<template>
  <reg-user-selector v-if="!readOnly && !field.readOnly"
                     :ref="inputRef"
                     v-model="fieldValue"
                     :role="field.role"
                     :hint="field.hint"
                     :persistent-hint="true"
                     :required="maybeCall(field.required, value)"
                     :disabled="field.disabled"
                     :multiple="field.multiple"
                     :label="label"
                     @input="fieldChanged" />
  <div v-else :class="{'reg-information': !small, 'reg-information-small': small}">
    <label>{{ field.label }}</label>
    <p>{{ readOnlyValue }}</p>
  </div>
</template>

<script>
import { defineComponent, computed, getCurrentInstance, toRef } from 'vue'
import { map } from 'lodash'
import { useDynamicField } from '../composables/useDynamicField'
import { useFieldFormatting } from '../composables/formatting/useFieldFormatting'
import UserSelector from '~shared/selectors/UserSelector.vue'

export default defineComponent({
  name: 'DynamicUserSelector',
  components: {
    'reg-user-selector': UserSelector
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit, expose }) {
    const instance = getCurrentInstance()
    const $store = instance?.proxy?.$store
    
    const {
      fieldValue,
      label,
      inputRef,
      maybeCall,
      fieldChanged,
      hasError
    } = useDynamicField({
      value: toRef(props, 'value'),
      field: props.field,
      readOnly: props.readOnly,
      isValidating: toRef(props, 'isValidating'),
      itemKey: props.itemKey,
      emptyValue: '',
      emit
    })

    const formattedValue = useFieldFormatting({
      model: computed(() => props.value),
      field: computed(() => props.field)
    })

    const readOnlyValue = computed(() => {
      const userIds = formattedValue.value
      const userNames = map(userIds, userId => {
        return $store.getters.getUserName(userId)
      })
      return userNames.join(', ')
    })

    // Expose properties for DynamicForm validation
    expose({
      hasError,
      validate: () => inputRef.value?.validate?.()
    })

    return {
      fieldValue,
      label,
      maybeCall,
      fieldChanged,
      readOnlyValue,
      inputRef
    }
  }
})
</script>

<style lang="scss">
</style>